// event-bus.js
import Vue from "vue";

const EventBus = new Vue();

// EventBus.$on("all", (event, ...args) => {});

export default EventBus;
